import React from "react";
// import messages from "../../icons/bxs_chat.svg";
import { ReactComponent as CloseIcon } from "../../icons/CloseIcon.svg";
import { ReactComponent as ChatIcon } from "../../icons/bxs_chat.svg";
import { SearchFilterOptionType } from "../../data/types";
import { MessageModal } from "../../molecules/Desktop/AppModal";


type MessagesProps = {
  username: string
  searchFilterOptions: SearchFilterOptionType
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const Messages: React.FC<MessagesProps> = ({username, searchFilterOptions, isOpen, setIsOpen}) => {
  const { setSignInModalIsOpen, messageCommunityId, setMessageCommunityId } = searchFilterOptions
  // const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      {!isOpen ? (
        <div className=" border-0 fixed bottom-0 right-0 m-5 md:m-10 z-[100]">
          <button 
            className="flex flex-row w-[270px] h-[74px] cursor-pointer border-0 shadow-md hover:shadow-lg bg-white rounded-[16px] transition-all duration-200 active:scale-95 relative z-[100]" 
            onClick={() => {
              if (username){
                setIsOpen(true)
              } else {
                setSignInModalIsOpen(true)
              }
            }}
          >
            <ChatIcon className="w-10 h-10 p-2 my-auto cursor-pointer bg-primaryDark-0 rounded-[16px] text-white" />
            <div className="flex flex-col text-start pl-1 pt-2">
              <div className="text-primaryDark-0 font-raleway font-bold">Need Help?</div>
              <div className="text-[14px] font-open-sans italic text-[#4D4D4D]">
                Tap here to chat
              </div>
            </div>
          </button>
        </div>
      ) : (
        <div className=" border-0 fixed bottom-0 right-0 m-5 md:m-10 z-[100] cursor-pointer">
          <button className="flex flex-row w-[270px] h-[74px] cursor-pointer border-0 shadow-md hover:shadow-lg bg-white rounded-[16px] transition-all duration-200 active:scale-95 relative z-[100]" onClick={() => setIsOpen(false)}>
            <CloseIcon className="w-10 h-10 p-2 my-auto bg-primaryDark-0 rounded-[16px] text-white" />
            <div className="flex flex-col text-start pl-1 pt-2" >
              <div className="text-primaryDark-0 font-raleway font-bold">Close</div>
              <div className="text-[14px] font-open-sans italic text-[#4D4D4D]">
                Not what you needed?
              </div>
            </div>
          </button>
        </div>
      )}
      <MessageModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        initialCommunityId={messageCommunityId}
        onClearInitialCommunity={() => setMessageCommunityId(undefined)}
      />
    </div>
  );
};

export default Messages;
